import axiosClient from './axiosClient';

const accountSettingsApi = {
  getAccount() {
    return axiosClient.get('/account');
  },

  updateProfile(payload) {
    return axiosClient.post('/account/profile', payload);
  },

  updateBusiness(payload) {
    return axiosClient.post('/account/business', payload);
  },

  updatePassword(payload) {
    return axiosClient.patch('/account/password', payload);
  },
};

export default accountSettingsApi;